var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchTransfer',{attrs:{"move-in":_vm.moveIn,"move-out":_vm.moveOut,"search":_vm.searchDepartment,"data":_vm.departments,"selected":_vm.selected,"get-title":_vm.departmentTitle,"get-tooltip":_vm.departmentTooltip,"list-width":"14rem"}})}
var staticRenderFns = []

export { render, staticRenderFns }